'use client';

import React, { useEffect, useState, useRef } from 'react';
import { Collapse, Input, Slider, Select, Pagination } from 'antd';
import CardEbook from '../../Card/Card';
import { useGlobalContext } from '../../context/provider';
import SelectZone from './SelectZone';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter } from "@fortawesome/free-solid-svg-icons";
import loading from '../../../../public/loading.gif'
import { AxiosGetData } from "../../context/axiosfunction"

const FilterDesktop = ({ selectdata, ebook, search, tag, setebook, catetypeBook }) => {
  const { screen, API, headers, privateKey } = useGlobalContext()
  const [filter, setFilter] = useState(false)
  const [TextSearch, setTextSearch] = useState('')
  const [page, setPage] = useState(1)
  const [filterSituation, setFilterSituation] = useState({})
  const [textquery, setTextquery] = useState('')
  const pageRef = useRef(page);

  const [loading, setLoading] = useState(false)
  const sentinelRef = useRef(null);
  const [selectCate, setSelectCate] = useState({ book_type: 'all', book_cate: 'all' })
  const queryRef = useRef('');
  const [hasMore, setHasMore] = useState(true);
  const normalize = (v) => (v === 'all' || v === '' || v === null || v === undefined ? undefined : v);

  useEffect(() => { queryRef.current = TextSearch; }, [TextSearch]);
  useEffect(() => { pageRef.current = page; }, [page]);



  useEffect(() => {
    if (!filterSituation) return;
    // console.log(filterSituation);

    // สร้างสำเนาที่ล้างค่าแล้ว
    const cleaned = {
      book_type: normalize(filterSituation.book_type),
      book_cate: normalize(filterSituation.book_cate),
      form: normalize(filterSituation.form),
      tag: normalize(filterSituation.tag),
      sort: normalize(filterSituation.sort),
      partner: normalize(filterSituation.partner),
      search:
        typeof filterSituation.search === 'string'
          ? (filterSituation.search.trim() || undefined)
          : undefined,
      status: normalize(filterSituation.status),
      lengthPrice: Array.isArray(filterSituation.lengthPrice)
        ? filterSituation.lengthPrice
        : undefined,
    };

    const urlParams = typeof window !== 'undefined' ? new URLSearchParams(window.location.search) : new URLSearchParams();
    const hasUrlQuery = urlParams.toString().length > 0 || (typeof search === 'string' && search.trim().length > 0) || (typeof tag === 'string' && tag.trim().length > 0);

    // ถ้าไม่มีค่าอะไรเลยก็ออก
    const hasFilter =
      hasUrlQuery ||
      cleaned.book_type !== undefined ||
      cleaned.form !== undefined ||
      cleaned.tag !== undefined ||
      cleaned.book_cate !== undefined ||
      cleaned.partner !== undefined ||
      cleaned.search !== undefined ||
      cleaned.status !== undefined ||
      cleaned.sort !== undefined ||
      (Array.isArray(cleaned.lengthPrice) &&
        (Number.isFinite(cleaned.lengthPrice[0]) ||
          Number.isFinite(cleaned.lengthPrice[1])));


    if (!hasFilter) {
      // เคส "ล้างทุกอย่าง" → โหลดหน้า 1 แบบไม่มี query
      (async () => {
        try {
          setLoading(true);
          setPage(1);
          pageRef.current = 1;
          const GetBook = await AxiosGetData(API, `/api/all_ebook?page=1`, headers, privateKey);
          setebook(GetBook);
          setTextSearch('');        // << สำคัญ: ทำให้ queryRef.current กลายเป็นสตริงว่าง
          setHasMore(true);   // reset ว่ายังโหลดได้
          // setPage(1);
          pageRef.current = 1;

        } finally {
          setLoading(false);
        }
      })();

      return;
    }

    const qs = new URLSearchParams(urlParams);

    if (urlParams.has('text') && !qs.has('search')) {
      qs.set('search', urlParams.get('text'));
      qs.delete('text');
    }

    if (cleaned.tag !== undefined) {
      qs.set('tag', String(cleaned.tag));
    } else if (filterSituation.tag === null || filterSituation.tag === 'all') {
      qs.delete('tag');
    }

    if (cleaned.book_type !== undefined) {
      qs.set('bkt', String(cleaned.book_type));
    } else if (filterSituation.book_type === null || filterSituation.book_type === 'all') {
      qs.delete('bkt');
    }

    if (cleaned.book_cate !== undefined) {
      qs.set('cate', String(cleaned.book_cate));
    } else if (filterSituation.book_cate === null || filterSituation.book_cate === 'all') {
      qs.delete('cate');
    }

    if (Array.isArray(cleaned.lengthPrice)) {
      const [min, max] = cleaned.lengthPrice;
      if (Number.isFinite(min)) qs.set('priceMin', String(min));
      if (Number.isFinite(max)) qs.set('priceMax', String(max));
    } else if (filterSituation.lengthPrice === null) {
      qs.delete('priceMin');
      qs.delete('priceMax');
    }

    if (cleaned.partner !== undefined) {
      qs.set('partner', String(cleaned.partner));
    } else if (filterSituation.partner === null || filterSituation.partner === '') {
      qs.delete('partner');
    }

    if (cleaned.search !== undefined) {
      qs.set('search', cleaned.search);
    } else if (filterSituation.search === null || filterSituation.search === '') {
      qs.delete('search');
    }

    if (cleaned.status !== undefined) {
      qs.set('status', String(cleaned.status));
    } else if (filterSituation.status === null || filterSituation.status === '') {
      qs.delete('status');
    }

    if (cleaned.form !== undefined) {
      qs.set('form', String(cleaned.form));
    } else if (filterSituation.form === null || filterSituation.form === '') {
      qs.delete('form');
    }

    if (cleaned.sort !== undefined) {
      qs.set('sort', String(cleaned.sort));
    } else if (filterSituation.sort === null || filterSituation.sort === '') {
      qs.delete('sort');
    }

    if (search && typeof search === 'string' && search.trim() !== '' && !qs.has('search')) {
      qs.set('search', search.trim());
    }

    if (tag && typeof tag === 'string' && tag.trim() !== '' && !qs.has('tag')) {
      qs.set('tag', tag.trim());
    }

    const queryString = qs.toString();
    // console.log(queryString);

    (async () => {
      try {
        setLoading(true);
        setPage(1);
        pageRef.current = 1;

        const GetBook = await AxiosGetData(
          API,
          `/api/all_ebook?page=1${queryString ? '&' + queryString : ''}`,
          headers,
          privateKey
        );
        setHasMore(true);
        setebook(GetBook);
        setTextSearch(queryString);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    })();
  }, [filterSituation, search, tag]);


  useEffect(() => {
    if (!sentinelRef.current) return;
    const io = new IntersectionObserver(async (entries) => {
      const [e] = entries;
      if (e.isIntersecting && hasMore && !loading) {
        const next = pageRef.current + 1;
        const query = queryRef.current;
        try {
          setLoading(true);
          const GetBook = await AxiosGetData(
            API,
            `/api/all_ebook?page=${next}${query !== '' ? '&' + query : ''}`,
            headers,
            privateKey
          );

          if (!GetBook || GetBook.length === 0) {
            setHasMore(false);
            setLoading(false);
            return;
          }
          setTimeout(() => {
            setebook(prev => [...prev, ...GetBook]);
            setLoading(false);
          }, [500])

          setPage(prev => {
            const np = prev + 1;
            pageRef.current = np;
            return np;
          });
        } catch (error) {
          console.error(error);
        }
      }
    }, {
      root: null,
      rootMargin: "300px",
      threshold: 0.01
    });

    io.observe(sentinelRef.current);
    return () => io.disconnect();
  }, [hasMore, loading]);

  const SerachByCat = (type, cate) => {
    // console.log(cate);

    setSelectCate({ book_type: type, book_cate: cate })
    if (cate === 'all') {
      setFilterSituation(prev => ({
        ...prev,
        book_type: null,
        book_cate: null,
      }));
      setTextSearch('')
    } else {
      setFilterSituation(prev => ({
        ...prev,
        book_type: type,
        book_cate: cate,
      }));
      setTextSearch('&' + 'cate=' + cate)

    }

  }

  // console.log(TextSearch);


  const items = catetypeBook
    .map((data, index) => {

      if (data.category.length === 0) return null;

      return {
        key: String(index),
        label: <div className={`text-[18px] font-bold ${selectCate.book_type == data.type_id ? 'text-[#EC008C]' : 'text-primary'} `}>{data.type_name}</div>,
        children: (
          <div className="flex flex-col text-[16px] gap-[8px] items-baseline px-[1em]">
            {data.category.map((item, key) => (
              <button onClick={() => SerachByCat(data.type_id, item.id)} className='text-primary font-normal cursor-pointer text-start' key={key}>
                <span className={`  ${selectCate.book_type == data.type_id && selectCate.book_cate == item.id ? 'text-[#EC008C]' : ''}`}>{item.name} </span>
              </button>
            ))}
          </div>
        ),
      };
    })


  return (
    <div className="self-start w-[100%] grid grid-cols-4 mb-[1em]  gap-[24px]">

      <div className='col-span-1'>
        <div className='text-[32px] font-medium my-[10px]'>หมวดอีบุ๊ก</div>
        <div className='shadow-[0_0_5px_rgba(205,187,180,0.3)] rounded-[4px] w-[100%]'>
          <div className={`px-[16px] py-[12px] text-primary text-[18px] font-medium cursor-pointer`}>
            <button onClick={() => SerachByCat('all', 'all')}>
              <span className={`${selectCate.book_type == 'all' && selectCate.book_cate == 'all' ? 'text-[#EC008C] cursor-pointer' : 'cursor-pointer'} `}>ทั้งหมด</span>
            </button>
          </div>
          <Collapse
            className="page-bg  search-draw font-bold w-[100%]"
            bordered={false}
            expandIconPosition="end"
            defaultActiveKey={items?.map((item) => item.key)}
            items={items}
          />
        </div>

      </div>
      <div className="col-span-3  flex flex-col gap-[1em]" >
        <div className='flex items-center pt-[24px] px-[24px] justify-end'>
          {/* <span className='text-[24px] font-medium'>ค้นหาอีบุ๊ก</span> */}
          {!filter &&
            <Input.Search placeholder='ชื่ออีบุ๊ค' onSearch={(e) => setFilterSituation(prev => ({
              ...prev,
              search: e,
              lengthPrice: null,
              form: null,
              partner: null,
              status: null,
              sort: null,
              // book_type:getType ===''? null : getType,
              // book_cate:getCate ===''? null : getCate
            }))} />
          }
          <button onClick={() => setFilter((prev) => !prev)} className='bg-[#5298EC] cursor-pointer text-white w-[149px] h-[40px] rounded-[4px] ml-[1em]'>ค้นหาแบบละเอียด</button>
        </div>
        {/* <div className='px-[24px] py-[10px]'>
          <Input value={TextSearch} onChange={(e)=>setTextSearch(e.target.value)} className='h-[40px] ' prefix placeholder='ค้นหา' allowClear />
        </div> */}
        <div className={`  grid grid-cols-12 overflow-hidden px-[24px] gap-[24px]  transition-[max-height] duration-300 ease-in-out
            ${filter ? 'max-h-[293px] mb-[15px]' : 'max-h-0 '} `}>
          <SelectZone setFilterSituation={setFilterSituation} selectdata={selectdata} />
        </div>

        <div className='px-[24px] grid grid-cols-12 gap-[16px] md:gap-[24px]'>
          <h1 className='text-[24px] font-medium col-span-12'>ผลการค้นหา </h1>
          {ebook?.length > 0 ?
            <>
              {ebook?.map((data, index) => (
                <div key={index} className='col-span-2'>
                  <CardEbook Ebookdata={data} type='SearchBook' />
                </div>
              ))}
            </>
            :
            <div className='col-span-12 flex flex-col gap-[1em] justify-center items-center'>
              <img src="https://eve-image.eveebook.com/image.eveebook/mascot/no1.png" alt="" />
              <div className="text-[18px] font-bold">ไม่พบหนังสือที่ต้องการ</div>
            </div>
          }
          <div ref={sentinelRef} style={{ height: 1 }} />
          {loading && <img src='https://eve-image.eveebook.com/image.eveebook/mascot/loading.gif' className="col-span-12 w-[200px] mx-auto" alt="loading" />}
        </div>

      </div>
    </div>
  );
};

export default FilterDesktop;